<template>
  <div>
    <!-- 添加产品 -->
    <!-- 添加产品弹框开始 -->
    <div class="main_dialog_one">
      <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="84.4%"
      center
      top="2vh"
    >
      <el-divider></el-divider>
      <div class="pxDialog">
        <el-form
          :label-position="labelPosition"
          :model="ruleForm"
          ref="ruleForms"
          label-width="130px"
          :rules="rules"
          class="demo-ruleForm"
          >
            <el-form-item label="产品模式:" prop="type">
              <el-radio-group v-model="ruleForm.type" @change="typeChange">
                <el-radio label="0">期票模式</el-radio>
                <el-radio label="1">日历模式</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="ones" >
              <el-form-item class="inputA" label="产品名称:" prop="ProductName">
                <el-input v-model="ruleForm.ProductName" placeholder="请输入产品名称"></el-input>
              </el-form-item>
              <el-form-item label="产品分类:" prop="ProductType">
                <el-select v-model="ruleForm.ProductType" @change="Types" placeholder="请选择产品分类">
                    <el-option
                      v-for="item in localTypeArr"
                      :key="item.typeid"
                      :label="item.typename"
                      :value="String(item.typeid)"
                    ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- <div class="ones" v-if="ruleForm.ProductType=='20'">
              
            </div> -->
            <!--  -->
            <div v-if="ruleForm.ProductType==20&&ruleForm.type==0">
              <div class="son_border" v-for="(item,index) in son" :key="index" >
                <el-form-item class="inputA" label="子产品名称:" >
                  <!-- <el-input v-model="item.productname_son" placeholder="请输入子产品名称"></el-input> -->
                  <el-select v-model="item.product_son_id"  placeholder="请选择产品名称">
                    <el-option
                      v-for="item in tableDataName"
                      :key="item.id"
                      :label="item.product_son_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="子产品数量:" >
                  <el-input v-model="item.son_number" onkeyup="this.value=this.value.replace(/\D|^0/g,'')"  placeholder="请输入子产品数量"></el-input>
                </el-form-item>
                <el-form-item label="子产品价格:" >
                  <el-input v-model="item.price_son" @input="limitNum(item.price_son,index)"  placeholder="请输入子产品价格"></el-input>
                </el-form-item>
                <!-- <el-form-item label="子产品分类:" >
                  <el-select v-model="item.type_son" clearable placeholder="请选择产品分类">
                      <el-option
                        v-for="item in sonOption"
                        :key="item.id"
                        :label="item.typename"
                        :value="item.id"
                      ></el-option>
                  </el-select>
                </el-form-item> -->
                <!-- {{index}} {{son.length}} -->
                <img src="@/assets/addpro.png" alt="" v-if="index+1==son.length" @click="addSonpro">
                <img src="@/assets/jianpro.png" alt="" v-if="index>0" @click="reduce(index)">
              </div>
            </div>
            <el-form-item class="inputA" label="产品简述:" >
              <el-input v-model="ruleForm.description" placeholder="请输入产品简述"></el-input>
            </el-form-item>
         
            <el-form-item label="产品描述:" >
              <div class="proA">
                <quill-editor 
                  v-model="ruleForm.Memo" 
                  ref="myQuillEditor" 
                >
              </quill-editor>
              </div>
            </el-form-item>
            <el-form-item label="发票开具说明:" >
              <quill-editor 
                v-model="ruleForm.Invoice" 
                ref="myQuillEditor" 
              >
              </quill-editor>
            </el-form-item>
            <el-form-item label="产品封面:">
              <div class="flex">
                <cutImageDialog :imgs="ruleForm.WebPic" @resurl="resurl" v-if="imsgflow"  />
                <span>注：请上传1M一下的图片(此图片用于平台产品宣传，请认真对待)，支持png、jpg、jpeg</span>
              </div>
            </el-form-item>  
            <el-form-item label="产品主图:" >
              <el-upload action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                :limit="5"
                :class="hideUpload?'hide':'width172'"
                :on-success="attachUploadSuccess"
                :data="datas" list-type="picture-card"
                ref="pictureUpload"
                :file-list="transDetImgList">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                    <span class="el-upload-list__item-actions">
                      <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
              </el-upload>
            </el-form-item>

            <!-- 第二步 -->
            <div class="disE" >
              <el-form-item label="销售有效期:">
                <el-radio-group v-model="ruleForm.ValidStatus" >
                  <!-- <el-radio label="1" v-if="ruleForm.type==0">无</el-radio> -->
                  <el-radio label="2">设置</el-radio>
                </el-radio-group>
              </el-form-item>
              <div v-if="ruleForm.ValidStatus=='2'" style="margin-left:2rem;">
                <el-date-picker
                  v-model="ValidTime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :clearable="false"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </div>
            </div>
            <el-form-item label="消费日期状态:" prop="ConsumeState">
              <!-- <span class="posiA">*</span> -->
              <!-- <div> -->
              <el-radio-group v-model="ruleForm.ConsumeState" >
                <el-radio label="1">景区设置</el-radio>
                <el-radio label="2">生效时间设置</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="disW" v-if="ruleForm.ConsumeState==2">

              <el-form-item label="开始时间:" >
                <span class="disR">
                  <span>购票</span>
                  <el-input v-model="ruleForm.Hour"  ></el-input>
                  <span>小时后</span>
                </span>
              </el-form-item>
            </div>
            <div class="disW"  >
              <el-form-item label="消费日期:"  v-if="ruleForm.ConsumeState=='1'">
                <!-- <span class="posiA">*</span> -->
                <div >
                  <el-date-picker
                  v-model="ConsumeTime"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  :clearable="false"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="消费截止日期:"  v-if="ruleForm.ConsumeState=='2'" >
                <div class="conendTime">
                  <el-date-picker
                  v-model="endtimes"
                  type="datetime"
                  :clearable="false"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  default-time="23:59:59"
                ></el-date-picker>
                </div>
              </el-form-item>
            </div>
            <el-form-item  v-if="ruleForm.type=='0'">
              <div class="disX">
                <el-checkbox v-model="checkAll" disabled @change="yesChange">可使用星期</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item >
              <div class="disN">
                <el-checkbox v-model="ruleForm.timeflag" disabled style="margin-right:2rem;">可用时间</el-checkbox>
                <el-time-picker
                  is-range
                  :clearable="false"
                  v-model="flagtime"
                  range-separator="至"
                  value-format="HH:mm"
                  format="HH:mm"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  @change="changeEnd"
                ></el-time-picker>
                <span>(24小时制)</span>
              </div>
            </el-form-item>
            <div class="disK" v-if="ruleForm.type==1">
              <el-form-item label="提前下单:">
                <el-input v-model="ruleForm.preday"></el-input>
                <span style="margin:0 10px;">天</span>
                <el-time-picker :clearable="false" v-model="ruleForm.pretime" placeholder="任意时间点" value-format="HH:mm" format="HH:mm"></el-time-picker>
                <span>前下单</span>
              </el-form-item>
            </div>
        

            <!-- 第三步  -->
            <div class="disF"  style="margin-top:2rem;">
              <el-form-item label="门市价:" prop="Price">
                <el-input type="number" v-model="ruleForm.Price"></el-input>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="disG" >
              <el-form-item label="建议销售价:" prop="SellPrice">
                <el-input type="number" v-model="ruleForm.SellPrice"></el-input>
                <div style="color:#FF4D4F;">注：微信商城售卖价、小程序售卖价格，小程序销售价和代理价格必须相同</div>
              </el-form-item>
              <span>元</span>
              <el-form-item label="代理价:" prop="AgentPrice">
                <el-input type="number" v-model="ruleForm.AgentPrice"></el-input>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="disH">
              <!-- <el-form-item label="押金金额:" >
                <el-input type="number" v-model="ruleForm.Deposit"></el-input>
              </el-form-item> -->
              <!-- <span>元</span> -->
              <el-form-item label="退票:">
                <el-radio-group v-model="ruleForm.ReturnFlag">
                  <el-radio label="1">禁止退票</el-radio>
                  <el-radio label="0">允许退票</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="disK flex_date" v-if="ruleForm.type==1">
              <el-form-item label="产品日历设置:">
                <el-button @click="dataSetFn()">产品日历详情设置</el-button>
              </el-form-item>
              <span>产品批量或单独设置后需保存产品才可生效</span>
            </div>

            <!-- 第四步 -->
            <div class="disL"  style="margin-top:2rem;">
              <el-form-item label="用户限购:">
                <el-input type="number" v-model="ruleForm.limit_buy" placeholder="请输入限购数量"></el-input>
              </el-form-item>
              <span>0为不限制数量 注：每个用户限购数量</span>
            </div>
            <div class="disL" v-if="ruleForm.type=='1'">
              <el-form-item label="日库存:">
                <el-input type="number" v-model="ruleForm.NumBerflag"></el-input>
              </el-form-item>
              <span>0为不限制数量</span>
            </div>
            <div class="disK" style="flex-wrap:wrap;" v-if="ruleForm.type=='0'">
              <el-form-item label="每日数量限制:" prop="NumBerflag">
                <!-- <span class="posiC">*</span> -->
                <el-input type="number" v-model="ruleForm.NumBerflag"></el-input>
                <span class="diskSpan">0为不限制数量 ( 请谨慎填写库存；您当前编辑的库存为总售卖库存量，非该团单的新增库存；库存数量为适用于所配置售卖日期的总数 )</span>
              </el-form-item>
              <el-form-item label="总量限制:" prop="Number">
                <!-- <span class="posiA">*</span> -->
                <el-input type="number" v-model="ruleForm.Number"></el-input>
                <span  class="diskSpan">0为不限制数量 ( 请谨慎填写库存；您当前编辑的库存为总售卖库存量，非该团单的新增库存；库存数量为适用于所配置售卖日期的总数 )</span>
              </el-form-item>
            </div>
            <div class="disK" v-if="ruleForm.type=='0'">
              <el-form-item label="每日预定数量限制:" prop="ReserveNumBerflag">
                <!-- <span class="posiV">*</span> -->
                <el-input type="number" v-model="ruleForm.ReserveNumBerflag"></el-input>
              </el-form-item>
              <span>0为不限制数量</span>
              <el-form-item label="预定总量限制:" prop="ReserveNumber">
                <!-- <span class="posiC">*</span> -->
                <el-input type="number" v-model="ruleForm.ReserveNumber"></el-input>
              </el-form-item>
              <span>0为不限制数量</span>
            </div>
            <el-form-item label="状态:">
              <el-radio-group v-model="ruleForm.UseFlag">
                <el-radio label="0">上线</el-radio>
                <el-radio label="1">下线</el-radio>
              </el-radio-group>
              <span class="spanA">
                <span>注:</span>
                <span>默认为允许销售,下线则不允许销售</span>
              </span>
            </el-form-item>
            <el-form-item label="是否同步到订单:" v-if="titleType!='添加产品'">
              <el-radio-group v-model="ruleForm.orderflag">
                <el-radio label="0">不同步到订单</el-radio>
                <el-radio label="1">同步到订单</el-radio>
              </el-radio-group>
              <span class="spanA">
                <span>注:</span>
                <span>同步到订单，会把未使用的订单信息修改，慎用！！！</span>
              </span>
            </el-form-item>
            <div style="color: #FF4D4F;">*以下设置仅限小程序使用</div>
            <div class="disK" v-if="ruleForm.type==1">
              <el-form-item label="完善身份证信息:">
                <el-radio-group v-model="ruleForm.radio" @change="handleChange">
                  <el-radio :label="1">需要（一证一票）</el-radio>
                  <el-radio :label="2">需要（一证多票）</el-radio>
                  <el-radio :label="0">不需要</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <el-form-item class="inputA" label="年龄限制范围:">
              <div class="form_ages">
                <el-input v-model="ruleForm.age_range_start" type="number" placeholder="请输入最小年龄">
                  <template slot="append">
                    岁
                  </template>
                </el-input>
                <span>-</span>
                <el-input v-model="ruleForm.age_range_end" type="number" placeholder="请输入最大年龄">
                  <template slot="append">
                    岁
                  </template>
                </el-input>
              </div>
            </el-form-item>
            <el-form-item class="inputA" label="地域限制:">
              <div class="form_ages">
                <el-select
                    v-model="ruleForm.province_name"
                    placeholder="请选择省"
                    clearable
                    @change="handleProvinceChange"
                    style="width: 300px;"
                  >
                    <el-option
                      v-for="province in provinceData"
                      :key="province"
                      :label="province"
                      :value="province"
                    />
                  </el-select>
                  <span>-</span>
                  <el-select
                    v-model="ruleForm.city_name"
                    placeholder="请选择市"
                    clearable
                    :disabled="!ruleForm.province_name"
                    style="width: 300px;"
                  >
                    <el-option
                      v-for="city in cityOptions"
                      :key="city"
                      :label="city"
                      :value="city"
                    />
                  </el-select>
              </div>
            </el-form-item>
            <el-form-item label="是否可过人脸:">
              <el-radio-group v-model="ruleForm.faceSet">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item >
              <div class="btn">
                <!-- <el-button @click="resetForm()" >上一步</el-button> -->
                <el-button class="btnL" @click="submitForm('ruleForms')">确认保存</el-button>
              </div>
            </el-form-item>
        </el-form>
        
      </div>
    </el-dialog>
    </div>
    <!-- 添加产品弹框结束 -->
    <!-- 产品日历设置开始 -->

    <div >
      <el-dialog :close-on-click-modal="false"
        title="产品日历设置"
        :visible.sync="dataDialogVisible"
        :before-close="dataHandleClose"
        width="80%"
        center
      >
        <el-divider></el-divider>
        <!-- v-if="dataType==1" -->
        <div class="dataForm" >
          <el-form ref="dataForm" :model="ruleForms" label-width="100px" :rules="ruleFormsRules">
            <el-form-item label="产品日历:">
              <el-radio-group v-model="ruleForms.radio" @change="radioFn">
                <el-radio label="1">批量设置</el-radio>
                <el-radio label="2">指定日期设置</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="消费日期:" prop="ProductTime" v-if="ruleForms.radio=='1'">
              <el-date-picker
                v-model="ProductTime"
                type="datetimerange"
                range-separator="至"
                :clearable="false"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="week" v-if="ruleForms.radio=='1'">
              <div class="disX">
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="checkAlls"
                  @change="handleCheckAllChange"
                >每日</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="ruleForms.week" @change="handleCheckedChanges">
                  <el-checkbox v-for="city in weeks" :label="city" :key="city">{{city}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="状态:" v-if="ruleForms.radio=='1'">
              <el-radio-group v-model="ruleForms.status">
                <el-radio label="1">售卖</el-radio>
                <el-radio label="2">停售</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="dataDis" v-if="ruleForms.radio=='1'">
              <el-form-item label="门市价:" prop="price">
                <el-input placeholder="请输入门市价" v-model="ruleForms.price" clearable></el-input>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="dataDis" v-if="ruleForms.radio=='1'">
              <el-form-item label="销售价:" prop="sellprice">
                <el-input placeholder="请输入销售价" v-model="ruleForms.sellprice" clearable></el-input>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="dataDis" v-if="ruleForms.radio=='1'">
              <el-form-item label="代理价:" prop="agentprice">
                <el-input placeholder="请输入代理价" v-model="ruleForms.agentprice" clearable></el-input>
              </el-form-item>
              <span>元</span>
            </div>
          </el-form>
        </div>
        <div class="btn" v-if="ruleForms.radio==1">
          <el-button>清空</el-button>
          <el-button class="btnL" @click="successBtns('dataForm')">确认</el-button>
        </div>
        <div class="dataZd" v-if="ruleForms.radio=='2'">
          <div class="btnHer">
            <div class="her" @click="getPreMonth" >
              上一个月
            </div>
            <div class="her" @click="getGoMonth" >
              下一个月
            </div>
          </div>
          <el-calendar v-model="value"  v-loading="loading">
              <div slot="dateCell" slot-scope="{date, data}" >
                <p
                  :class="data.isSelected ? 'is-selected' : ''"
                 >{{ data.day }} {{ data.isSelected ? '✔️' : ''}}</p>
                <div v-for="(item,index) in dateList" :key="`${data.day}-${index}`"  v-if="data.day==item.date">
                  <el-form class="itemFome" ref="form"  label-width="80px" v-if="item.status=='1'">
                    <el-form-item label="门市价:">
                      <el-input v-model="item.price" @blur="rate(item)"></el-input>
                    </el-form-item>
                    <el-form-item label="售卖价:">
                      <el-input v-model="item.sellprice" @blur="Selling(item)"></el-input>
                    </el-form-item>
                    <el-form-item label="代理价:">
                      <el-input v-model="item.agentprice" @blur="Agency(item)"></el-input>
                    </el-form-item>
                    <el-form-item label="库存:">
                      <el-input v-model="item.numberflag"   @blur="inventory(item)"></el-input>
                    </el-form-item>
                    <el-form-item label="销售/剩余:">
                      {{ item.sales}} / {{item.daynumber == "-9" ? "无限制" : item.numberflag - item.sales}}
                    </el-form-item>
                  </el-form>
                  <div v-if="item.status=='2'" class="ting">停售</div>
                  <div v-if="item.status=='21'" class="ting">售罄</div>
                </div>
              </div>
          </el-calendar>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getProductSonList ,getProductInfo,AddScenicProduct,SetBatchProduct,UpdateScenicProduct,SetAloneProduct,CldDateList,ScenicProductSonType} from '@/request/scenic.js'
import { Message ,MessageBox} from "element-ui";
import { provinceData, cityData } from '@/components/adress/adress';
import cutImageDialog from '@/assets/place.vue'
const weekOptions = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日"
];
export default {
  components: { cutImageDialog },
  props:['typeArr'],
  data() {
    const validatorDate = (rule, value, callback) => {
      return value !== '' ? callback() : callback(new Error(rule.message));
    };
    return {
      cityOptions: [],
      provinceData,
      cityData,
      step:[
        {
          value:'1',
          label:'产品详情'
        },
        {
          value:'2',
          label:'日期设置'
        },
        {
          value:'3',
          label:'价格设置'
        },
        {
          value:'4',
          label:'销售设置'
        }
      ],
      DetailFlow:false,
      transDetImgList:[],
      dateList:[
      ],
      ProductID:'',
      ProductTime:'',
      checkAlls:'0',
      labelPosition: "right",
      addProDialogVisible: false, // 添加产品弹框
      dataDialogVisible: false, // 添加产品产品日历设置弹框
      // dataZdDialogVisible: false, // 指定日期弹框
      titleType: "", // 弹框标题名
      // 图片
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      ruleForm: {
        faceSet: '2',//是否可过人脸
        province_name:'',
        city_name:'', 
        age_range_start:'',
        age_range_end:'',
        product_son:[],
        UsePeopleNum:'1',
        radio:'0',//完善身份证信息
        radio1:'1',//身份证刷门禁进入
        token:window.sessionStorage.getItem('Token'),
        ProductType:'1',// 类型
        ProductName:"",// 产品名称
        description:'',//	简介
        type:'0',//产品模式
        ValidStatus:'2', // 销售有效期状态码
        ValidBeginDate:'', //销售有效期开始日期
        ValidEndDate:'', //销售有效期结束日期
        ConsumeState:'1', //消费日期状态
        ConsumeBeginDate:'', // 消费有效期开始日期
        ConsumeEndDate:'',// 消费有效期结束日期
        Hour:'',//生效时间
        weekflag:'', // 可使用星期状态
        weeks:'',//可使用星期
        timeflag:'', //可使用时间状态
        usebegintime:'', // 使用时间开始时间
        useendtime:'', // 使用时间结束时间
        preday:'',//	提前几天下单
        Price:'',// 门市价
        SellPrice:'',//	建议销售价
        AgentPrice:'', //分销商代理价
        Deposit:'',//押金
        ReturnFlag:'0',//退款
        NumBerflag:'',//每日数量限制
        Number:'',//总数量限制
        ReserveNumBerflag:'',//每日预定数量限制
        ReserveNumber:'',//预定总限制
        WebPic:'',//互联网产品图片地址
        Memo:'\t\t\t\t\t\t<p>【使用人群】：</p>\r\n\t\t\t\t\t\t\t<p>【预定时间】：</p>\r\n\t\t\t\t\t\t\t<p>【有效期】：</p>\r\n\t\t\t\t\t\t\t<p>【费用包含】：</p>\r\n\t\t\t\t\t\t\t<p>【适用条件】：</p>\r\n\t\t\t\t\t\t\t<p>【取票方式】：</p>\r\n\t\t\t\t\t\t\t<p>【其他须知】：</p>\r\n\t\t\t\t\t\t\t<p>【联系电话】：</p>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<p><br></p>', // 产品描述
        pretime:'',// 在几点前下单
        openTime:'',
        closeTime:'',
        minimumTime:'',
        place:'',
        UseFlag:'0',
        Invoice:'',
        image1:'',
        image2:'',
        image3:'',
        image4:'',
        image5:'',
        orderflag:'',
        limit_buy:'0'
      },
      tableDataName:'', 
      rules: {
        ProductName: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        ProductType: [
          { required: true, message: "请选择产品分类", trigger: "change" }
        ],
        type: [
          { required: true, message: "请选择产品模式", trigger: "change" }
        ],
        ConsumeState: [
          { required: true, message: "请选择消费日期状态", trigger: "change" }
        ],
        ConsumeEndDate:[
          { required: true, message: "请选择销售有效期", trigger: "change" }
        ],
        Invoice:[
          { required: true, message: "请输入发票开具说明", trigger: "blur" },
        ],
        NumBerflag:[
          { required: true, message: "请输入每日数量限制", trigger: "blur" },
        ],
        ReserveNumBerflag:[
          { required: true, message: "请输入每日预定数量限制", trigger: "blur" },
        ],
        ReserveNumber:[
          { required: true, message: "请输入预定总限制", trigger: "blur" },
        ],
        Number:[
          { required: true, message: "请输入总数量限制", trigger: "blur" },
        ],
        Price:[
          { required: true, message: "请输入门市价", trigger: "blur" },
          { validator: this.validateAmount, trigger: 'blur' }
        ],
        SellPrice:[
          { required: true, message: "请输入建议销售价", trigger: "blur" },
          { validator: this.validateAmount, trigger: 'blur' }
        ],
        AgentPrice:[
            { required: true, message: "请输入代理价", trigger: "blur" },
           { validator: this.validateAmount, trigger: 'blur' }
        ],
       
      },
      ruleForms:{
        radio:'1',
        start_date:'',
        end_date:'',
        week:[],
        status:'1',
        price:'',
        sellprice:'',
        agentprice:''
      },
      ruleFormsRules:{
        price: [
          { required: true, message: "请输入门市价", trigger: "blur" },
        ],
        sellprice: [
          { required: true, message: "请输入销售价", trigger: "blur" },
        ],
        agentprice: [
          { required: true, message: "请输入代理价", trigger: "blur" },
        ],
        week: [
          { required: true, message: "请选择星期", trigger: "change" }
        ],
        ProductTime: [
        { required: true, message: '日期是必填字段', validator: validatorDate }
        ],
      },
      radio: "1",
      input: "",
      radioType: "", // 产品日历类别
      dataType: "", // 日历类别弹框
      checkAll: true,
      checkedCities: ['星期一','星期二','星期三','星期四','星期五','星期六','星期日',],
      cities: weekOptions,
      weeks:weekOptions,
      isIndeterminate: true,
      value1: '',
      ValidTime:[], //销售有效期 开始结束时间 
      ConsumeTime:'', //消费有效期 开始结束时间 
      flagtime:['00:00','23:59'],
      options:[
        {
          value:1,
          label:'全场'
        },
        {
          value:2,
          label:'半场'
        }
      ],
      datas:{
        token:window.sessionStorage.getItem('Token')
      },
      fileList:'',
      cldkey:'',
      cldkey1:'',
      loading:true,
      yesChangeFlow:false,
      hideUpload:false,
      imsgflow:false,
      endtimes:'',
      value:new Date(),
      text:'下一步',
      son:[
        {
          productname_son:'',
          son_number:'',
          price_son:'',
          product_son_id:''
        }
      ],
      sonOption:[],
      localTypeArr: [], // 本地副本
      originalTypeArr: [] // 原始数据副本
    };
  },
  created(){
    this.yesChangeFlow=false
    this.initTypeArr()
    let data = {
      token:window.sessionStorage.getItem('Token')
    }
    ScenicProductSonType(data).then(res=>{
      if(res.data.status=='ok'){
        this.sonOption = res.data.result
      }
    })
  },
  watch: {
     typeArr: {
      immediate: true,
      handler(newVal) {
        this.initTypeArr()
        this.$nextTick(() => this.alignProductTypeWithOptions())
      }
    },
    'ruleForm.type'(newVal) {
      if (newVal == 1) {
        this.localTypeArr = this.localTypeArr.filter(item => item.typename !== "套票")
      } else if (newVal == 0) {
        this.localTypeArr = [...this.originalTypeArr]
      }
    }
  },
  methods: {
    initTypeArr() {
      this.localTypeArr = JSON.parse(JSON.stringify(this.typeArr))
      this.originalTypeArr = JSON.parse(JSON.stringify(this.typeArr))
    },
    handleInput(item,e,index){
      this.dateList[index].stock1 = e
      this.$forceUpdate()
    },
    changeEnd(e){
      if(e[0]==e[1]){
        this.flagtime = ['00:00','23:59']
        Message.error('开始时间与结束时间不能相同')
      }
    },
    Types(e){
      this.syncTypenameFromProductType()
      const n = Number(e)
      if (n === 20 || e === '20'){
        this.son = [
          {
            productname_son:'',
            son_number:'',
            price_son:'',
            product_son_id:''
          }
        ]
        let data = {
          token:window.sessionStorage.getItem('Token'),
        }
        getProductSonList(data).then(res=>{
          if(res.data.status=='ok'){
            this.tableDataName = res.data.result
          }
        })
      }
    },
    syncTypenameFromProductType() {
      const v = this.ruleForm.ProductType
      if (v == null || v === '') return
      const hit = this.localTypeArr.find(item => String(item.typeid) === String(v))
      if (hit) this.$set(this.ruleForm, 'typename', hit.typename)
    },
    // 下拉选项 value 与接口 ProductType / typename 对齐，避免只显示 id
    alignProductTypeWithOptions() {
      if (!this.ruleForm || !this.localTypeArr || this.localTypeArr.length === 0) return
      const raw = this.ruleForm.ProductType
      const nameFromApi = (this.ruleForm.typename || '').toString().trim()
      let hit = null
      if (raw !== '' && raw !== null && raw !== undefined) {
        hit = this.localTypeArr.find(item => String(item.typeid) === String(raw))
      }
      if (!hit && nameFromApi) {
        hit = this.localTypeArr.find(
          item => (item.typename || '').toString().trim() === nameFromApi
        )
      }
      if (hit) {
        this.$set(this.ruleForm, 'ProductType', String(hit.typeid))
        this.$set(this.ruleForm, 'typename', hit.typename)
      }
    },
    limitNum(amount,index) {
      amount = amount
        .replace(/[^\d.]/g, "") //只能输入数字
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3") //只能输入两个小数
        .replace(/\.{2,}/g, "."); //出现多个点时只保留第一个
      // 第一位不让输小数点
      if (amount == ".") {
        amount = "";
      }
      // 如果第一位是0，第二位必须大于0或者小数点
      if (amount.substring(0, 1) == 0) {
        if (amount.substring(1, 2) > 0) {
          amount = amount.substring(1, 2);
        } else if (
          amount.substring(1, 2) === 0 ||
          amount.substring(1, 2) === "0"
        ) {
          amount = "0";
        }
      } else {
        // 如果第一位数字大于0（不等于0肯定就大于0），仅需考虑第二位是小数点的情况
        if (amount.indexOf(".") != -1) {
          if (amount.substring(0, 1) > 0) {
            console.log("第一位大于0");
          } else {
            console.log("第一位等于0");
            if (amount.substring(2, 3) > 0) {
              console.log("小数点后第一位大于0");
            } else {
              console.log("小数点后第一位等于0");
              amount = "0.";
            }
          }
        } else {
          console.log("没有小数点，正常输入");
        }
      }
      this.son[index].price_son = amount;
    },
    handleChange() {
      if(this.ruleForm.radio==0){
        this.ruleForm.age_range_start=''
        this.ruleForm.age_range_end=''
      }
      this.$forceUpdate()
    },
    reduce(index){
      this.son.splice(index,1)
    },
    addSonpro(){
      if(this.son.length==5){
        Message.error('子产品最多添加五个')
        return false
      }
      this.son.push({
        productname_son:'',
        son_number:'',
        price_son:'',
      })
    },
    validateAmount(rule, value, callback) {
      // 自定义校验函数的实现
      let as = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      
      // 检查是否为数字且大于等于0，并且符合格式要求
      if (isNaN(value) || value < 0 || !as.test(value)) {
        callback(new Error('输入金额不合法,必须大于等于0且小数点后最多两位'))
      } else {
        callback()
      }
    },
    typeChange(e){
      if(e==1){
        this.ruleForm.ConsumeState = '1'
      }
    },
    // 第一天
    getStartTime(e) {
        let date = new Date(e)
        date.setDate(1) // 将当前时间的日期设置成第一天
        let year= date.getFullYear()  // 得到当前年份 
        let month = date.getMonth()  + 1 // 得到当前月份（0-11月份，+1是当前月份）
        month  = month > 10 ? month :'0' + month // 补零
        let day  = date.getDate() // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
        return  (day<10?'0'+day:day)// 这里传入的是字符串
    },
    // 最后一天
    getEndTime(e){
      let  date  = new Date(e)
      let year = date.getFullYear()  
      let month = date.getMonth() +1
    // 这里传入的是整数时间，返回的是下个月的第一天，因为月份是0-11
      let nextMonthFirthDay = new Date(year,month,1) // 下个月的第一天
      console.log(nextMonthFirthDay)
      let oneDay = 1000*60 * 60 * 24 // 一天的时间毫秒数
      let endDay = new Date(nextMonthFirthDay - oneDay) 
      let day = endDay.getDate() // 本月最后一天
      // 这里传入的是字符串格式的时间，返回的是传入字符串的时间
      return (day<10?'0'+day:day)
    },

    getTime(date){
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h =date.getHours()
      h = h < 10 ? ('0' + h) : h
      let M =date.getMinutes()
      M = M < 10 ? ('0' + M) : M
      let s =date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      return y + '-' + m + '-' + d 
      // + ' ' + h + ':' + M + ':' + s;
    },
    // 点击获取上个月
    getPreMonth() {
      let date = this.getTime(this.value)
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - 1;
      if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      this.value = new Date(t2)
      if(this.ProductID==''){
        this.dateList.map(item=>{
          item.agentprice = this.ruleForm.AgentPrice
          item.price = this.ruleForm.Price
          item.sellprice=  this.ruleForm.SellPrice
          item.stock = Number(this.ruleForm.NumBerflag)
          item.status = '1'
        })
        return false
      }
      this.dateList = []
      this.allcalendar(t2)
    },
    getGoMonth(){
      let date = this.getTime(this.value)
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + 1;
      if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      this.value = new Date(t2)
      if(this.ProductID==''){
        this.dateList.map(item=>{
          item.agentprice = this.ruleForm.AgentPrice
          item.price = this.ruleForm.Price
          item.sellprice=  this.ruleForm.SellPrice
          item.stock = Number(this.ruleForm.NumBerflag)
          item.status = '1'
        })
        this.$forceUpdate()
        return false
      }
      this.dateList = []
      this.allcalendar(t2)
    },
     // 第一天
     getStartTime1(e) {
        let date = new Date(e)
        date.setDate(1) // 将当前时间的日期设置成第一天
        let year= date.getFullYear()  // 得到当前年份 
        let month = date.getMonth()  + 1 // 得到当前月份（0-11月份，+1是当前月份）
        month  = month > 10 ? month :'0' + month // 补零
        let day  = date.getDate() // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
        return  (day<10?'0'+day:day)// 这里传入的是字符串
    },
    // 最后一天
    getEndTime1(e){
      let  date  = new Date(e)
      let year = date.getFullYear()  
      let month = date.getMonth() +1
    // 这里传入的是整数时间，返回的是下个月的第一天，因为月份是0-11
      let nextMonthFirthDay = new Date(year,month,1) // 下个月的第一天
      console.log(nextMonthFirthDay)
      let oneDay = 1000*60 * 60 * 24 // 一天的时间毫秒数
      let endDay = new Date(nextMonthFirthDay - oneDay) 
      let day = endDay.getDate() // 本月最后一天
      // 这里传入的是字符串格式的时间，返回的是传入字符串的时间
      return (day<10?'0'+day:day)
    },
    allcalendar(e){
      var date = new Date(e);
      let firstDay =  this.getStartTime(e)
      let lastDay = this.getEndTime(e)
      var year = date.getFullYear(); // 年
      var month = date.getMonth() + 1; // 月
      var first = year + '-' + (month<10?'0'+month:month) + '-' + firstDay
      var last = year + '-' + (month<10?'0'+month:month)  + '-' + lastDay 
      let data = {
        token:window.sessionStorage.getItem('Token'),
        goods_id:this.ProductID,
        startTime:first,
        endTime:last
      }
      CldDateList(data).then(res=>{
        if(res.data.rcode==200){
          this.dateList =  res.data.result
          this.dateList.map(item=>{
            // item.stock = Number(item.daynumber)
            item.price1 = item.price
            item.sellprice1 = item.sellprice
            item.agentprice1 = item.agentprice
            item.stock1 = item.daynumber
          })
          this.$forceUpdate() 
          this.loading = false
        }else{
          this.loading = false
          Message.error('当前无数据')
        }
      })
    },
    yesChange(e){
      if(this.yesChangeFlow==false){
        this.$nextTick(function(){
          this.checkAll = true
          this.checkedCities = ['星期一', '星期二','星期三', '星期四','星期五', '星期六','星期日']
          this.yesChangeFlow=true
        })
      }
      if(e){
        this.checkedCities = ['星期一', '星期二','星期三', '星期四','星期五', '星期六','星期日']
      }else{
        this.checkedCities = []
      }
    },
    rate(item){
      if(item.price==item.price1){
        return false
      }
      let flag = item.numberflag == item.stock1
      let data = {
        token:window.sessionStorage.getItem('Token'),
        day:item.date,
        price:item.price,
        sellprice:item.sellprice,
        agentprice:item.agentprice,
        stock:item.numberflag,
        stype: flag ? '1' : '3',
        cldkey:''
      }
      if(this.cldkey1!=''){
        data.cldkey = this.cldkey1
      }
      console.log(data,'--------')
      SetAloneProduct(data).then(res=>{
        if(res.data.rcode==200){
                this.cldkey = res.data.result
                this.cldkey1 = res.data.result
                Message({
                    type: "success",
                    message: "日历设置成功"
               })
         
        }
      })
    },
    Selling(item){
      if(item.sellprice==item.sellprice1){
        return false
      }
      let flag = item.numberflag == item.stock1
      let data = {
        token:window.sessionStorage.getItem('Token'),
        day:item.date,
        price:item.price,
        sellprice:item.sellprice,
        agentprice:item.agentprice,
        stock:item.numberflag,
        stype:flag ? '1' : '3',
        cldkey:''
      }
      if(this.cldkey1!=''){
        data.cldkey = this.cldkey1
      }
      SetAloneProduct(data).then(res=>{
        if(res.data.rcode==200){
          this.cldkey = res.data.result
          this.cldkey1 = res.data.result
          Message({
              type: "success",
              message: "日历设置成功"
          })
        }
      })
    },
    Agency(item){
      if(item.agentprice==item.agentprice1){
        return false
      }
      let flag = item.numberflag == item.stock1
      let data = {
        token:window.sessionStorage.getItem('Token'),
        day:item.date,
        price:item.price,
        sellprice:item.sellprice,
        agentprice:item.agentprice,
        stock:item.numberflag,
        stype:flag ? '1' : '3',
        cldkey:''
      }
      if(this.cldkey1!=''){
        data.cldkey = this.cldkey1
      }
      SetAloneProduct(data).then(res=>{
        if(res.data.rcode==200){
                this.cldkey = res.data.result
                this.cldkey1 = res.data.result
                Message({
                    type: "success",
                    message: "日历设置成功"
               })
         
        }
      })
    },
    inventory(item){
      if(item.numberflag==item.stock1){
        return false
      }
      let flag = item.price == item.price1 && item.agentprice == item.agentprice1 && item.sellprice == item.sellprice1
      let data = {
        token:window.sessionStorage.getItem('Token'),
        day:item.date,
        price:item.price,
        sellprice:item.sellprice,
        agentprice:item.agentprice,
        stock:item.numberflag,
        stype:flag ? '2' : '3',
        cldkey:''
      }
      if(this.cldkey1!=''){
        data.cldkey = this.cldkey1
      }
      SetAloneProduct(data).then(res=>{
        if(res.data.rcode==200){
                this.cldkey = res.data.result
                this.cldkey1 = res.data.result
                Message({
                    type: "success",
                    message: "日历设置成功"
               })
        }
      })
    },
    // 日历批量设置
    successBtns(dataForm){
      this.$refs[dataForm].validate((valid)=>{
        if(valid){
          var arr = []
          if(this.ruleForms.week.length!=0){
            this.ruleForms.week.map(item=>{
              switch(item){
                case '星期一':
                arr.push('1')
                    break;
                case '星期二':
                arr.push('2')
                    break;
                case '星期三':
                arr.push('3')
                    break;
                case '星期四':
                arr.push('4')
                    break;
                case '星期五':
                arr.push('5')
                    break;
                case '星期六':
                arr.push('6')
                    break;
                case '星期日':
                arr.push('7')
                    break;
                default:
                    break;
              }
            })
          }
          let data = {
            token:window.sessionStorage.getItem('Token'),
            start_date:this.ProductTime[0],
            end_date:this.ProductTime[1],
            week:arr,
            status:this.ruleForms.status,
            price:this.ruleForms.price,
            sellprice:this.ruleForms.sellprice,
            agentprice:this.ruleForms.agentprice
          }
          SetBatchProduct(data).then(res=>{
              if(res.data.rcode==200){
                this.cldkey = res.data.result
                Message({
                    type: "success",
                    message: "日历设置成功"
                })
                this.dataDialogVisible = false;
              }else{
                Message.error(res.data.msg)
              }
            })
        }else{
        }
      })
    },
    getDetail(row){
      this.ProductID = row.ProductID
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ProductID:row.ProductID
      }
      getProductInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.cldkey = res.data.result.cldkey
          res.data.result.orderflag = 0 + ''
          this.ruleForm = res.data.result
          this.ruleForm.Invoice = res.data.result.invoice_instructions
          this.ruleForm.ReturnFlag = res.data.result.ReturnFlag + ''
          this.ruleForm.type = res.data.result.type + ''
          this.ruleForm.ValidStatus = res.data.result.ValidStatus+''
          this.ruleForm.ConsumeState = res.data.result.ConsumeState + ''
          this.ruleForm.timeflag = res.data.result.timeflag=='1'?true:false
          this.ruleForm.UseFlag = res.data.result.UseFlag + ''
          this.checkAll = res.data.result.weekflag=='1'?true:false
          this.ruleForm.radio = Number(res.data.result.IDCard)
          this.ruleForm.radio1 =   '1'
          this.ConsumeTime = [res.data.result.ConsumeBeginDate,res.data.result.ConsumeEndDate]
          this.endtimes = res.data.result.ConsumeEndDate
          this.ValidTime = [res.data.result.ValidBeginDate,res.data.result.ValidEndDate]
          this.flagtime = [res.data.result.usebegintime,res.data.result.useendtime]
          this.ruleForm.openTime = res.data.result.openTime
          this.dialogImageUrl = res.data.result.WebPic
          this.ruleForm.age_range_start = res.data.result.age_range_start
          this.ruleForm.age_range_end = res.data.result.age_range_end
          this.ruleForm.limit_buy = res.data.result.limit_buy?res.data.result.limit_buy:0
          this.ruleForm.province_name = res.data.result.province_name
          this.ruleForm.city_name = res.data.result.city_name,
          this.ruleForm.faceSet = String(res.data.result.faceSet)
          if(res.data.result.ProductType!=20){
            this.son = [
              {
                productname_son:'',
                son_number:'',
                price_son:'',
              }
            ]
          }else{
            let data = {
              token:window.sessionStorage.getItem('Token'),
            }
            getProductSonList(data).then(res=>{
              if(res.data.status=='ok'){
                this.tableDataName = res.data.result
              }
            })
            this.son = res.data.result.product_son
          }
          // 如果省份有值，初始化城市选项
          if (this.ruleForm.province_name) {
            this.cityOptions = this.cityData[this.ruleForm.province_name] || []
          }
          // 产品分类回显：typename + ProductType 与下拉 options 对齐（统一为字符串 typeid）
          if (res.data.result.typename != null && res.data.result.typename !== '') {
            this.$set(this.ruleForm, 'typename', res.data.result.typename)
          }
          this.$nextTick(() => {
            this.alignProductTypeWithOptions()
            if (!this.ruleForm.typename) this.syncTypenameFromProductType()
          })
          this.$forceUpdate()
          if(res.data.result.weeks!=''){
            this.ruleForm.weeks = JSON.parse(res.data.result.weeks)
            this.checkedCities = []
            this.ruleForm.weeks.map(item=>{
              switch (item) {
                    case '7':
                        this.checkedCities.push('星期日')
                        break;
                    case '6':
                        this.checkedCities.push('星期六')
                        break;
                    case '5':
                        this.checkedCities.push('星期五')
                        break;
                    case '4':
                        this.checkedCities.push('星期四')
                        break;
                    case '3':
                        this.checkedCities.push('星期三')
                        break;
                    case '2':
                        this.checkedCities.push('星期二')
                        break;
                    case '1':
                        this.checkedCities.push('星期一')
                        break;
                   default:
              }
            })
            if(this.checkedCities.length=='7'){
              this.checkAll = true
            }
          }else{
            this.checkedCities = []
            this.checkAll = false
          }

          let img = []
          if(this.ruleForm.image1){
            img.push({
              url:this.ruleForm.image1
            })
          }
          if(this.ruleForm.image2){
            img.push({
              url:this.ruleForm.image2
            })
          }
          if(this.ruleForm.image3){
            img.push({
              url:this.ruleForm.image3
            })
          }
          if(this.ruleForm.image4){
            img.push({
              url:this.ruleForm.image4
            })
          }
          if(this.ruleForm.image5){
            img.push({
              url:this.ruleForm.image5
            })
          }
          this.transDetImgList = img;
        }
      })
    },
    // 单选框日历
    radioFn(e) {
      if(e==2){
          const loading = this.$loading({
            lock: true,
            text: '数据加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            loading.close();
          }, 1000);
          if(this.ProductID){
            var data = {}
            if(new Date(this.getCurrentMonthFirst()).getTime()>new Date(this.ProductTime[0]).getTime()){
              if(new Date(this.getLastDay(this.ProductTime[0])).getTime()>new Date(this.ProductTime[1]).getTime()){
                var enD = this.ProductTime[1] 
              }else{
                var enD = this.getLastDay()
              }
              data = {
                token:window.sessionStorage.getItem('Token'),
                goods_id:this.ProductID,
                startTime:this.getCurrentMonthFirst(),
                endTime:enD.slice(0,10)
              }
            }else{
              this.value = new Date(this.ProductTime[0])
              if(new Date(this.getLastDay(this.ProductTime[0]))>new Date(this.ProductTime[1])){
                var enD = this.ProductTime[1]
              }else{
                var enD = this.getLastDay(this.ProductTime[0])
              }
              data = {
                token:window.sessionStorage.getItem('Token'),
                goods_id:this.ProductID,
                startTime:this.getCurrentMonthFirst(),
                endTime:enD.slice(0,10)
              }
            }
            CldDateList(data).then(res=>{
              if(res.data.rcode==200){
                this.dateList =  res.data.result
                this.dateList.map(item=>{
                  // item.stock = Number(item.daynumber)
                  item.price1 = item.price
                  item.sellprice1 = item.sellprice
                  item.agentprice1 = item.agentprice
                  item.stock1 = item.numberflag
                })
                this.$forceUpdate() 
                this.loading = false
              }else{
                this.loading = false
                Message.error('当前无数据')
              }
            })
          }else{
            this.value = new Date()
            this.dateList.map(item=>{
              item.agentprice = this.ruleForm.AgentPrice
              item.price = this.ruleForm.Price
              item.sellprice=  this.ruleForm.SellPrice
              item.stock = this.ruleForm.NumBerflag
              item.status = '1'
            })
            this.$forceUpdate() 
            this.loading = false
          }
      }
    },
    // 最后一天
    getLastDay(e){
        if(e){
          var dateObj = new Date(e)
        }else{
          var dateObj = new Date()
        }
        var y = dateObj.getFullYear(); //获取年份
        var m = dateObj.getMonth() + 1; //获取月份
        var d = new Date(y, m, 0).getDate(); //获取当月最后一日
        m = m < 10 ? '0' + m : m; //月份补 0
        d = d < 10 ? '0' + d : d; //日数补 0
        return [y,m,d].join("-")
    },   
    // 第一天
    getCurrentMonthFirst(){
        var dateObj = new Date()
        var y = dateObj.getFullYear(); //获取年份
        var m = dateObj.getMonth() + 1; //获取月份
        var d = '01';
        m = m < 10 ? '0' + m : m; //月份补 0
        return [y,m,d].join("-")
    },
    // 点击产品日历
    dataSetFn() {
      if(this.ConsumeTime){
        this.ProductTime = this.ConsumeTime
        this.getEveryDay(this.ConsumeTime[0],this.ConsumeTime[1])
        this.dataDialogVisible = true;
        this.ruleForms.week = ['星期一','星期二','星期三','星期四','星期五','星期六','星期日']
        this.ruleForms.price = this.ruleForm.Price
        this.ruleForms.sellprice = this.ruleForm.SellPrice
        this.ruleForms.agentprice = this.ruleForm.AgentPrice
        this.checkAlls = true
      }else{
        Message.error('请设置消费日期')
      }
      // // if (this.dataType == 1) {
      // // this.dataZdDialogVisible = true;
      // // }
    },
    getEveryDay(startTime, endTime) {
         //初始化日期列表，数组
      var allDate = new Array();
      var i = 0;
      this.dateList = []
      //开始日期小于等于结束日期,并循环
      while (startTime <= endTime) {
        allDate[i] = startTime;
        //获取开始日期时间戳
        var startTime_ts = new Date(startTime).getTime();
        //增加一天时间戳后的日期
        var next_date = startTime_ts + 24 * 60 * 60 * 1000;
        //拼接年月日，这里的月份会返回（0-11），所以要+1
        var next_dates_y = new Date(next_date).getFullYear() + "-";
        var next_dates_m =
          new Date(next_date).getMonth() + 1 < 10 ?
          "0" + (new Date(next_date).getMonth() + 1) + "-" :
          new Date(next_date).getMonth() + 1 + "-";
        var next_dates_d =
          new Date(next_date).getDate() < 10 ?
          "0" + new Date(next_date).getDate() :
          new Date(next_date).getDate();
        startTime = next_dates_y + next_dates_m + next_dates_d;
        //增加数组key
        i++;
      }
        allDate.map(item=>{
          this.dateList.push({
            date: item,
            agentprice : this.ruleForm.AgentPrice,
            price : this.ruleForm.Price,
            sellprice:   this.ruleForm.SellPrice,
            stock :  this.ruleForm.NumBerflag,
            status :  '1'
          });
        })
        this.$forceUpdate() 
      },
      getDate(datestr) {
        var temp = datestr.split("-");
        var date = new Date(temp[0], temp[1], temp[2]);
        return date;
      },
    // 点击产品日历指定日期X
    // dataZdHandleClose() {
    //   this.dataZdDialogVisible = false;
    // },
    // 点击产品日历X
    dataHandleClose() {
      this.dataDialogVisible = false;
      this.ruleForms.radio = '1'
    },
    submitForm(ruleForms) {
      if(this.ruleForm.ProductName==''){
        Message.error('请输入产品名称')
        return false
      }
      
      if(this.ruleForm.ProductType==''){
        Message.error('请选择产品分类')
        return false
      }
      if(this.ruleForm.description==''){
        Message.error('请输入产品简述')
        return false
      }
      if(this.ruleForm.Memo==''){
        Message.error('请输入产品描述')
        return false
      }
      if(this.ruleForm.ProductType==20){
        if(this.son.length>=2){
        }else{
          console.log(this.son.length)
          Message.error('套票产品必须大于两个')
          return false
        }
      }
      if(this.ValidTime==''||this.ValidTime==null){
        Message.error('请选择销售有效期')
        return false
      }
      if(this.ruleForm.pretime==''||this.ruleForm.pretime==null){
        if(this.ruleForm.pretime==null&&this.ruleForm.type==1){
          Message.error('请选择提前下单时间')
          return false
        }
      }
      if(this.ConsumeTime==''&&this.endtimes==''){
        Message.error('请选择消费日期')
        return false
      }
      if(this.ruleForm.type=='1'){
        if(this.ruleForm.age_range_start){
          if(this.ruleForm.radio=='1'){
            if(!this.ruleForm.age_range_end){
              Message.error('请输入完整年龄限制范围')
              return false
            }
          }else{
            Message.error('完善身份信息请选择需要（一证一票）')
            return false
          }
        }
        if(this.ruleForm.age_range_end){
          if(this.ruleForm.radio=='1'){
            if(!this.ruleForm.age_range_start){
              Message.error('请输入完整年龄限制范围')
              return false
            }
          }else{
            Message.error('完善身份信息请选择需要（一证一票）')
            return false
          }
        }
        if(this.ruleForm.province_name){
          if(this.ruleForm.radio=='1'){
            if(!this.ruleForm.city_name){
              Message.error('请选择市区')
              return false
            }
          }else{
            Message.error('输入地域限制请选择需要（一证一票）')
            return false
          }
        }
        if(this.ruleForm.city_name){
          if(this.ruleForm.radio=='1'){
            if(!this.ruleForm.province_name){
              Message.error('请选择省份')
              return false
            }
          }else{
            Message.error('输入地域限制请选择需要（一证一票）')
            return false
          }
        }
      }else{
        if(this.ruleForm.age_range_start){
          if(!this.ruleForm.age_range_end){
            Message.error('请输入完整年龄限制范围')
            return false
          }
        }
        if(this.ruleForm.age_range_end){
          if(!this.ruleForm.age_range_start){
            Message.error('请输入完整年龄限制范围')
            return false
          }
        }
         if(this.ruleForm.province_name){
          if(!this.ruleForm.city_name){
            Message.error('请选择完整省份市区')
            return false
          }
        }
        if(this.ruleForm.city_name){
          if(!this.ruleForm.province_name){
            Message.error('请选择完整省份市区')
            return false
          }
        }
      }
      if(this.ruleForm.age_range_start&&this.ruleForm.age_range_end){
        if(Number(this.ruleForm.age_range_end)<Number(this.ruleForm.age_range_start)){
          Message.error('请输入正确的年龄限制范围')
          return false
        }
      }

      if(this.ruleForm.ConsumeState=='2'){
        if(this.ruleForm.Hour==''&&this.ruleForm.Hour!=0){
          Message.error('请输入生效时间')
          return false
        }
      }
      if(this.ruleForm.Price==''){
        Message.error('请输入门市价')
        return false
      }else{
        if(Number(this.ruleForm.Price)<0){
          Message.error('门市价不能小于0')
          return false
        }
      }
      if(this.ruleForm.SellPrice==''){
        Message.error('请输入建议销售价')
        return false
      }else{
        if(Number(this.ruleForm.SellPrice)<0){
          Message.error('建议销售价不能小于0')
          return false
        }
      }
      if(this.ruleForm.AgentPrice==''){
        Message.error('请输入代理价')
        return false
      }else{
        if(Number(this.ruleForm.AgentPrice)<0){
          Message.error('代理价不能小于0')
          return false
        }
      }
   

      if(this.ruleForm.NumBerflag==''&&this.ruleForm.NumBerflag!=0){
        Message.error('请输入每日数量限制')
        return false
      }
      if(this.ruleForm.limit_buy==''&&this.ruleForm.limit_buy!=0){
        Message.error('请输入限购数量')
        return false
      }
      if(this.ruleForm.ReserveNumBerflag==''&&this.ruleForm.ReserveNumBerflag!=0){
        Message.error('请输入每日预定数量限制')
        return false
      }
      if(this.ruleForm.ReserveNumber==''&&this.ruleForm.ReserveNumber!=0){
        Message.error('请输入预定总量限制')
        return false
      }
      if(this.ProductID){ 
          var arr = []
          if(this.checkedCities.length!=0){
            this.checkedCities.map(item=>{
              switch(item){
                case '星期一':
                arr.push('1')
                    break;
                case '星期二':
                arr.push('2')
                    break;
                case '星期三':
                arr.push('3')
                    break;
                case '星期四':
                arr.push('4')
                    break;
                case '星期五':
                arr.push('5')
                    break;
                case '星期六':
                arr.push('6')
                    break;
                case '星期日':
                arr.push('7')
                    break;
                default:
                    break;
              }
            })
          }
          if(this.ruleForm.type=='1'){
            arr = ''
          }
          this.$refs[ruleForms].validate((valid) => {
          if (valid) {
            // if(this.ruleForm.type=='1'){
            //   this.ruleForm.ConsumeState='1'
            // }
            let data  = {
              token:window.sessionStorage.getItem('Token'),
              ProductType:this.ruleForm.ProductType, // 产品类型1
              ProductName:this.ruleForm.ProductName, // 	产品名称1
              description:this.ruleForm.description, // 简介
              type:this.ruleForm.type,  //产品模式1
              ValidStatus:this.ruleForm.ValidStatus,//销售有效期状态码
              ValidBeginDate:this.ruleForm.ValidStatus=='1'?'':this.ValidTime[0],//销售有效期开始日期
              ValidEndDate:this.ruleForm.ValidStatus=='1'?'':this.ValidTime[1], //销售有效期结束日期
              ConsumeState:this.ruleForm.ConsumeState, //消费日期状态1
              ConsumeBeginDate:this.ruleForm.ConsumeState=='1'?this.ConsumeTime[0]:'',//消费有效期开始日期
              ConsumeEndDate:this.ruleForm.ConsumeState=='1'?this.ConsumeTime[1]:this.endtimes,//消费有效期结束日期1
              Hour:this.ruleForm.ConsumeState=='2'?this.ruleForm.Hour:'', //生效时间1
              weekflag:this.checkAll==true?'1':'0',//可使用星期状态1
              weeks:this.checkAll==true?arr:'',//可使用星期
              timeflag:this.ruleForm.timeflag==true?'1':'0',//可使用时间状态
              usebegintime:this.ruleForm.timeflag==true?this.flagtime[0]:'0',//使用时间开始时间
              useendtime:this.ruleForm.timeflag==true?this.flagtime[1]:'0',//使用时间结束时间
              preday:this.ruleForm.preday,//提前几天下单
              Price:this.ruleForm.Price,//门市价
              SellPrice:this.ruleForm.SellPrice,//建议销售价
              AgentPrice:this.ruleForm.AgentPrice,//分销商代理价
              Deposit:this.ruleForm.Deposit,//押金
              ReturnFlag:this.ruleForm.ReturnFlag,//退款
              NumBerflag:this.ruleForm.NumBerflag,//每日数量限制
              Number:this.ruleForm.Number,//总数量限制
              ReserveNumBerflag:this.ruleForm.ReserveNumBerflag,//每日预定数量限制
              ReserveNumber:this.ruleForm.ReserveNumber,//预定总限制
              WebPic:this.ruleForm.WebPic,//互联网产品图片地址
              Memo:this.ruleForm.Memo,//产品描述
              openTime:this.ruleForm.ProductType=='3'?this.ruleForm.openTime:'',//	场馆开始时间
              closeTime:this.ruleForm.ProductType=='3'?this.ruleForm.closeTime:'',//场馆结束时间
              minimumTime:this.ruleForm.ProductType=='3'?this.ruleForm.minimumTime:'',//最少起订时间
              place:this.ruleForm.ProductType=='3'?this.ruleForm.place:'',//场地类型
              serialNumber:this.ruleForm.ProductType=='3'?this.ruleForm.serialNumber:'',//场地编码
              UseFlag:this.ruleForm.UseFlag,//上线状态
              Invoice:this.ruleForm.Invoice,//发票
              image1:this.ruleForm.image1,
              image2:this.ruleForm.image2,
              image3:this.ruleForm.image3,
              image4:this.ruleForm.image4,
              image5:this.ruleForm.image5,
              card_access:this.ruleForm.radio=='1'?'1':'2',
              IDCard:this.ruleForm.type=='0'?'0':this.ruleForm.radio,
              UsePeopleNum:'1',
              cldkey:this.cldkey,
              pretime:this.ruleForm.pretime,
              ProductID:this.ProductID,
              orderflag:this.ruleForm.orderflag,
              limit_buy:this.ruleForm.limit_buy,
              age_range_start:this.ruleForm.age_range_start,
              age_range_end:this.ruleForm.age_range_end,
              province_name:this.ruleForm.province_name,
              city_name:this.ruleForm.city_name,
              faceSet:this.ruleForm.faceSet
            }
            let product_son = []
            if(this.ruleForm.ProductType==20){
              if(this.son.length!=0){
                this.son.map(item=>{
                  item.productson_id = item.id
                  this.tableDataName.map(itm=>{
                    if(item.product_son_id==itm.id){
                      item.productname_son = itm.product_son_name
                    }
                  })
                  product_son.push(item)
                })
              }
              data.product_son = product_son
            }
            if(data.product_son){
              data.product_son.map(item=>{
                if(!item.id){
                  item.id = ''
                }
              })
            }
            if(this.ruleForm.orderflag=='1'){
              const loading = this.$loading({
                lock: true,
                text: '订单同步中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              UpdateScenicProduct(data).then(res=>{
                if(res.data.rcode==200){
                  loading.close();
                  Message.success('修改成功')
                  this.addProDialogVisible = false
                  this.$emit('ProClose')
                  this.ValidTime=''
                  this.ConsumeTime=''
                  this.ProductID=''
                  this.endtimes = ''
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              UpdateScenicProduct(data).then(res=>{
              if(res.data.rcode==200){
                Message.success('修改成功')
                this.addProDialogVisible = false
                this.$emit('ProClose')
                this.ValidTime=''
                this.ConsumeTime=''
                this.ProductID=''
                this.endtimes = ''
              }else{
                Message.error(res.data.msg)
              }
            })
            }
          } else {
            Message.error(res.data.msg)
            return false;
          }
        });
      }else{
        var arr = []
        if(this.checkedCities.length!=0){
          this.checkedCities.map(item=>{
            switch(item){
              case '星期一':
              arr.push('1')
                  break;
              case '星期二':
              arr.push('2')
                  break;
              case '星期三':
              arr.push('3')
                  break;
              case '星期四':
              arr.push('4')
                  break;
              case '星期五':
              arr.push('5')
                  break;
              case '星期六':
              arr.push('6')
                  break;
              case '星期日':
              arr.push('7')
                  break;
              default:
                  break;
            }
          })
        }
        if(this.ruleForm.type=='1'){
            arr = ''
        }
        this.$refs[ruleForms].validate((valid) => {
            if (valid) {
              let data  = {
                token:window.sessionStorage.getItem('Token'),
                ProductType:this.ruleForm.ProductType, // 产品类型1
                ProductName:this.ruleForm.ProductName, // 	产品名称1
                description:this.ruleForm.description, // 简介
                type:this.ruleForm.type,  //产品模式1
                ValidStatus:this.ruleForm.ValidStatus,//销售有效期状态码
                ValidBeginDate:this.ruleForm.ValidStatus=='1'?'':this.ValidTime[0],//销售有效期开始日期
                ValidEndDate:this.ruleForm.ValidStatus=='1'?'':this.ValidTime[1], //销售有效期结束日期
                ConsumeState:this.ruleForm.ConsumeState, //消费日期状态1
                ConsumeBeginDate:this.ruleForm.ConsumeState=='1'?this.ConsumeTime[0]:'',//消费有效期开始日期
                ConsumeEndDate:this.ruleForm.ConsumeState=='1'?this.ConsumeTime[1]:this.endtimes,//消费有效期结束日期1
                Hour:this.ruleForm.ConsumeState=='2'?this.ruleForm.Hour:'', //生效时间1
                weekflag:this.checkAll==true?'1':'0',//可使用星期状态1
                weeks:this.checkAll==true?arr:'',//可使用星期
                timeflag:this.ruleForm.timeflag==true?'1':'0',//可使用时间状态
                usebegintime:this.ruleForm.timeflag==true?this.flagtime[0]:'0',//使用时间开始时间
                useendtime:this.ruleForm.timeflag==true?this.flagtime[1]:'0',//使用时间结束时间
                preday:this.ruleForm.preday,//提前几天下单
                Price:this.ruleForm.Price,//门市价
                SellPrice:this.ruleForm.SellPrice,//建议销售价
                AgentPrice:this.ruleForm.AgentPrice,//分销商代理价
                Deposit:this.ruleForm.Deposit,//押金
                ReturnFlag:this.ruleForm.ReturnFlag,//退款
                NumBerflag:this.ruleForm.NumBerflag,//每日数量限制
                Number:this.ruleForm.Number,//总数量限制
                ReserveNumBerflag:this.ruleForm.ReserveNumBerflag,//每日预定数量限制
                ReserveNumber:this.ruleForm.ReserveNumber,//预定总限制
                WebPic:this.ruleForm.WebPic,//互联网产品图片地址
                Memo:this.ruleForm.Memo,//产品描述
                openTime:this.ruleForm.ProductType=='3'?this.ruleForm.openTime:'',//	场馆开始时间
                closeTime:this.ruleForm.ProductType=='3'?this.ruleForm.closeTime:'',//场馆结束时间
                minimumTime:this.ruleForm.ProductType=='3'?this.ruleForm.minimumTime:'',//最少起订时间
                place:this.ruleForm.ProductType=='3'?this.ruleForm.place:'',//场地类型
                serialNumber:this.ruleForm.ProductType=='3'?this.ruleForm.serialNumber:'',//场地编码
                UseFlag:this.ruleForm.UseFlag,//上线状态
                Invoice:this.ruleForm.Invoice,//发票
                image1:this.ruleForm.image1,
                image2:this.ruleForm.image2,
                image3:this.ruleForm.image3,
                image4:this.ruleForm.image4,
                image5:this.ruleForm.image5,
                card_access:this.ruleForm.radio1,
                IDCard:this.ruleForm.type=='0'?'0':this.ruleForm.radio,
                UsePeopleNum:'1',
                cldkey:this.cldkey,
                pretime:this.ruleForm.pretime,
                limit_buy:this.ruleForm.limit_buy,
                age_range_start:this.ruleForm.age_range_start,
                age_range_end:this.ruleForm.age_range_end,
                province_name:this.ruleForm.province_name,
                city_name:this.ruleForm.city_name,
                faceSet:this.ruleForm.faceSet
              }
              if(this.ruleForm.ProductType=='20'){
                data.product_son = this.son
              }
              AddScenicProduct(data).then(res=>{
                if(res.data.rcode==200){
                  Message.success('添加成功')
                  this.$emit('ProClose')
                  this.addProDialogVisible = false
                  this.ValidTime=''
                  this.ConsumeTime=''
                  this.endtimes = ''
                  this.ProductID=''
                }else{
                  Message.error(res.data.msg)
                }
              })
            } else {
              Message.error(res.data.msg)
              return false;
            }
          });
      }
    },
    handleRemove(file) {
      if(this.transDetImgList.length!=0){
        this.transDetImgList.map((item,index)=>{
          if(item.url==file.url){
            switch(index){
              case 0:
                this.ruleForm.image1 = ''
                  break;
                case 1:
                this.ruleForm.image2 = ''
                    break;
                case 2:
                this.ruleForm.image3 = ''
                    break;
                case 3:
                this.ruleForm.image4 = ''
                    break;
                case 4:
                this.ruleForm.image5 = ''
                  break;
              default:
                  break;
            }
          }
        })
      }
      if(this.fileList.length!=0){
        this.fileList.map((item,index)=>{
          if(item.name==file.name){
              switch(index){
                case 0:
                  this.ruleForm.image1 = ''
                    break;
                  case 1:
                  this.ruleForm.image2 = ''
                      break;
                  case 2:
                  this.ruleForm.image3 = ''
                      break;
                  case 3:
                  this.ruleForm.image4 = ''
                      break;
                  case 4:
                  this.ruleForm.image5 = ''
                    break;
                default:
                    break;
              }
          }
        })
      }
      if(this.transDetImgList.length<5){
        this.hideUpload = false
      }
      this.$refs.pictureUpload.handleRemove(file)
    },
    attachUploadSuccess(response, file, fileList){
      this.fileList = fileList
      switch(fileList.length){
            case 1:
              this.ruleForm.image1 =response.result
                break;
            case 2:
              this.ruleForm.image2 =response.result
                  break;
              case 3:
              this.ruleForm.image3 =response.result
                  break;
              case 4:
              this.ruleForm.image4 =response.result
                  break;
              case 5:
              this.ruleForm.image5 = response.result
                break;
            default:
                break;
      }
      if(this.fileList.length==5){
        this.hideUpload = true
      }
    },
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    // 封面主图
    handleAvatarSuccess(res, file) {
      this.ruleForm.WebPic = res.result
    },
    resurl(response){
      this.ruleForm.WebPic = response
    },
    handleCheckAllChange(val) {
      this.ruleForms.week = val ? weekOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      if(value.length==0){
        this.checkAll = false
      }else{
        this.checkAll = true
      }
      let checkedCount = value.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    handleCheckedChanges(value){
      let checkedCount = value.length;
      this.checkAlls = checkedCount === this.weeks.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.weeks.length;
    },
    // 添加产品
    addProFn(row) {
      if (row) {
        // 详情
        this.titleType = "产品详情";
        this.DetailFlow = true
        this.getDetail(row)
      } else {
        // 添加产品
        this.titleType = "添加产品"
        this.DetailFlow = false
        this.ruleForm={
          UsePeopleNum:'1',
          radio:0,//完善身份证信息
          radio1:'2',//身份证刷门禁进入
          token:window.sessionStorage.getItem('Token'),
          ProductType: '1' ,// 类型（保存仍传 ProductType，与下拉 value 统一为字符串）
          typename:'',// 分类名称展示
          ProductName:"",// 产品名称
          description:'',//	简介
          type:'0',//产品模式
          ValidStatus:'2', // 销售有效期状态码
          ValidBeginDate:'', //销售有效期开始日期
          ValidEndDate:'', //销售有效期结束日期
          ConsumeState:'1', //消费日期状态
          ConsumeBeginDate:'', // 消费有效期开始日期
          ConsumeEndDate:'',// 消费有效期结束日期
          Hour:'',//生效时间
          weekflag:'', // 可使用星期状态
          weeks:'',//可使用星期
          timeflag:true, //可使用时间状态
          usebegintime:'', // 使用时间开始时间
          useendtime:'', // 使用时间结束时间
          preday:'0',//	提前几天下单
          Price:'',// 门市价
          SellPrice:'',//	建议销售价
          AgentPrice:'', //分销商代理价
          Deposit:'',//押金
          ReturnFlag:'0',//退款
          NumBerflag:'0',//每日数量限制
          Number:'0',//总数量限制
          ReserveNumBerflag:'0',//每日预定数量限制
          ReserveNumber:'0',//预定总限制
          WebPic:'',//互联网产品图片地址
          Memo:'\t\t\t\t\t\t<p>【使用人群】：</p>\r\n\t\t\t\t\t\t\t<p>【预定时间】：</p>\r\n\t\t\t\t\t\t\t<p>【有效期】：</p>\r\n\t\t\t\t\t\t\t<p>【费用包含】：</p>\r\n\t\t\t\t\t\t\t<p>【适用条件】：</p>\r\n\t\t\t\t\t\t\t<p>【取票方式】：</p>\r\n\t\t\t\t\t\t\t<p>【其他须知】：</p>\r\n\t\t\t\t\t\t\t<p>【联系电话】：</p>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<p><br></p>', // 产品描述
          pretime:'10:00',// 在几点前下单
          openTime:'',
          closeTime:'',
          minimumTime:'',
          place:'',
          UseFlag:'0',
          Invoice:'',
          image1:'',
          image2:'',
          image3:'',
          image4:'',
          image5:'',
          limit_buy:'0',
          province_name: '',
          city_name: '',
          age_range_start: '',
          age_range_end: '',
        }
      }
      // 添加、编辑均显示产品封面裁剪框
      this.imsgflow = true
      this.addProDialogVisible = true
      this.$nextTick(() => {
        if (!this.DetailFlow) this.syncTypenameFromProductType()
      })
    },
    // 添加产品X
    addProHandleClose() {
      MessageBox("此操作将不会保存当前内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.addProDialogVisible = false;
          this.$emit('addProClose')
          this.ValidTime=''
          this.ConsumeTime=''
          this.endtimes = ''
          this.ProductID=''
          this.ruleForm.province_name = '' // 重置省份
          this.ruleForm.city_name = ''     // 重置城市
          this.cityOptions = []            // 重置城市选项
          this.faceSet = '2'
          this.imsgflow = false
        })
        .catch(() => {
        })
    },
    radioUpdate(){
      this.$forceUpdate()
    },
    // 省份改变事件
    handleProvinceChange(provinceName) {
      // 清空城市选择
      this.ruleForm.city_name = '';
      
      // 更新城市选项
      this.cityOptions = provinceName ? this.cityData[provinceName] || [] : [];
      
      // 触发更新
      this.$forceUpdate();
    },
    
    // 城市改变事件
    handleCityChange(cityName) {
      // 这里可以添加城市改变后的逻辑
      console.log('选择的城市:', cityName);
      this.$forceUpdate();
    },
  }
};
</script>

<style lang='less' scoped>
.top_radio{
  display: flex;
  justify-content: center;
}
.product-type-row{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  width: 100%;
}
.product-type-name{
  flex: 1;
  min-width: 12rem;
  max-width: 20rem;
}
.product-type-select{
  flex: 1;
  min-width: 12rem;
  max-width: 20rem;
}
.ones{
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  .el-form-item{
    &:nth-child(1){
      width: 40rem;
    }
    &:nth-child(2){
      width: 40rem;
    }
  }
}

.swiper_btn{
  width: 100%;
  display: flex;
  justify-content: center;
  .btns_four{
    width: 11rem;
    height: 4rem;
    border-radius: 0.4rem;
    background: #D9D9D9;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    margin-right: 2rem;
    cursor: pointer;
  }
  .stepActive{
    background: #246DEB;
  }
}





.dataForm {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -80px;
    color: #ff4d4f;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #ff4d4f;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -65px;
    color: #ff4d4f;
  }
  .disX {
    width: 439px;
    height: 80px;
    display: flex;
    // background: red;
    .el-checkbox {
      margin-right: 20px;
    }
  }
  .dataDis {
    display: flex;
    .el-input {
      width: 563px;
    }
    > span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      color: #666666;
      margin-left: 10px;
    }
  }
}
.pxDialog {
  .flex {
    display: flex;
    align-items: center;
    >span {
      color: #FF4D4F;
      font-size: 1.4rem;
      line-height: 1.4rem;
      display: block;
      margin-left: 2rem;
    }
  }
  .el-form-item__label {
    position: relative;
  }
  .posiA {
    position: absolute;
    top: 0px;
    left: -80px;
    color: #ff4d4f;
  }
  .posiB {
    position: absolute;
    top: 0px;
    left: -107px;
    color: #ff4d4f;
  }
  .posiC {
    position: absolute;
    top: 0px;
    left: -107px;
    color: #ff4d4f;
  }
  .posiD {
    position: absolute;
    top: 0px;
    left: -122px;
    color: #ff4d4f;
  }
  .posiE {
    position: absolute;
    top: 0px;
    left: -135px;
    color: #ff4d4f;
  }
  .posiF {
    position: absolute;
    top: 0px;
    left: -67px;
    color: #ff4d4f;
  }
  .posiG {
    position: absolute;
    top: 0px;
    left: -94px;
    color: #ff4d4f;
  }
  .posiL {
    position: absolute;
    top: 0px;
    left: -73px;
    color: #ff4d4f;
  }
  .posiV {
    position: absolute;
    top: 0px;
    left: -135px;
    color: #ff4d4f;
  }
  .posiZ {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #ff4d4f;
  }
  .el-form {
    width: 81.9rem;
    margin: auto;
  }

  .disK {
    .el-button {
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      text-align: center;
      color: #246deb;
    }
  }
  .disL {
    display: flex;
   
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      color: #ff4d4f;
      margin: 0 3rem;
    }
  }
  .spanA {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ff4d4f;
    > span:nth-child(1) {
      margin: 0 10px;
    }
  }
  .disK {
    display: flex;
    .el-input {
      width: 15rem;
    }
    > span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      text-align: right;
      color: #ff4d4f;
      margin: 0 2rem 0 10px;
    }
    .diskSpan{
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      text-align: right;
      color: #ff4d4f;
      margin: 0 2rem 0 10px;
    }
  }

  .disN {
    display: flex;
    align-items: center;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ff4d4f;
      margin-left: 10px;
    }
  }
  .disX {
    display: flex;
    // background: red;
    .el-checkbox {
      margin-right: 20px;
    }
  }
  .xfrq {
    .el-date-editor {
      // width: 600px;
    }
  }
  .disW {
    display: flex;
    .inputW {
      .el-date-editor {
        width: 230px;
      }
    }
    .el-input {
      width: 50px;
    }
  }
  .disE {
    display: flex;
    margin-top: 2rem;
    .el-date-editor {
      // width: 490px;
    }
  }
  .disH {
    display: flex;
    .el-input {
      width: 256px;
      margin-right: 10px;
    }
    > span {
      line-height: 40px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: right;
      color: #666666;
      margin-right: 50px;
    }
  }
  .disG {
    display: flex;
    justify-content: space-between;
    .el-input {
      // width: 256px;
      margin-right: 10px;
    }
    > span:nth-child(2) {
      line-height: 40px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: right;
      color: #666666;
      margin-right: 50px;
      margin-left: 1rem;
    }
    > span:nth-child(4) {
      line-height: 40px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: right;
      color: #666666;
      margin-right: 50px;
      margin-left: 1rem;
    }
  }
  .disF {
    display: flex;
    >.el-form-item{
      width: 100%;
    }
    .el-button {
      width: 145px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      text-align: center;
      color: #246deb;
    }
    > span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      text-align: right;
      color: #666666;
      margin: 0 20px 0 10px;
    }
  }
  .proFm {
    display: flex;
    >span{
      display: flex;
      align-items: end;
      width: 42.1rem;
      color: red;
      margin-bottom: 2rem;
      margin-left: 2rem;
    }
  }
 
  .disB {
    display: flex;
    .el-input {
      width: 80px;
      margin-right: 10px;
    }
    /deep/.el-form-item__content {
      margin: 0 45px;
    }
  }
  .disA {
    display: flex;
    .el-select {
      width: 280px;
      height: 40px;
      margin-right: 50px;
    }
    .el-input {
      width: 256px;
      height: 40px;
      margin-right: 10px;
    }
    .el-date-editor {
      width: 280px;
      height: 40px;
      margin-right: 50px;
    }
  }
  /deep/ .el-form-item__label {
    font-family: OPPOSans;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    /* identical to box height */
    text-align: right;
    color: #666;
  }
  // .inputA {
  //   // background: red;
  //   .el-input {
  //     width: 740px;
  //     height: 40px;
  //   }
  // }
}
.btn {
  margin: 20px 0 30px 0;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}
/deep/.is-selected {
  color: #1989fa;
}
/deep/.el-calendar-table td.is-selected {
    background-color: none;
}
/deep/thead {
  th {
    margin-right: 10px;
    text-align: center !important;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    background: #246deb;
    border-radius: 4px 4px 0px 0px;
  }
}
tbody {
  p {
    width: 198px;
    text-align: center;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
  }
}
/deep/.prev {
  width: 200px;
}
/deep/.el-calendar-table tr td:first-child {
  border: none;
}
/deep/.el-calendar-table td {
  border: none;
}
/deep/.el-calendar-day {
  box-sizing: border-box;
  padding: 10px 0;
  height: 26rem;
  width: 20rem;
  background: #eaf1fd;
  border-top: 3px solid #87aff4;
}
/deep/.el-calendar-table{
  >thead{
    >th:nth-of-type(6){
      background: #4ECB73;
    }
    >th:nth-of-type(7){
      background: #4ECB73;
    }
  }
}

/deep/.el-calendar-table__row{
  >td:nth-of-type(6){
    .el-calendar-day{
      border-top: 3px solid #4ECB73;
      // border-bottom: 3px solid #4ECB73;
    }
  }
  >td:nth-of-type(7){
    .el-calendar-day{
      border-top: 3px solid #4ECB73;
      // border-bottom: 3px solid #4ECB73;
    }
  }
}
.itemFome {
  /deep/.el-input {
    width: 100px;
    height: 30px;
  }
  /deep/.el-input__inner {
    height: 30px;
  }
  /deep/.el-form-item {
    margin-bottom: 0px;
  }
}
/deep/.ant-message{
  z-index: 99999!important;
}
.main_dialog_one /deep/.el-dialog{
  height: 95% !important;
  overflow: auto;
}
.messageClass{
  z-index: 3000 !important;
}
::v-deep .avatar{
  width: 148px;
  height: 148px;
}
::v-deep .avatar-uploader{
  background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 146px;
    height: 146px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
  border-color: #409EFF;
  display: flex;
  align-content: center;
    color: #409EFF;
    justify-content: center;
}
.spanB {
      display: flex;
      align-items: flex-end;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      color: #ff4d4f;
      margin-bottom: 20px;
      > span:nth-child(1) {
        margin: 0 10px;
      }
    }
/deep/ .el-upload-list__item>div{
  height: 100%;
}

/deep/ .el-dialog{
  min-width: 900px;
}
.hide /deep/ .el-upload--picture-card {
	display: none;
}
/deep/ .width172 .el-upload{
  width: 17.2rem;
  height: 9.6rem;
  line-height: 11.2rem;
}
/deep/ .width172 .el-upload-list__item,/deep/ .width172 .el-upload-list__item div{
  width: 17.2rem;
  height: 9.6rem;
  line-height: 11.2rem;
  vertical-align: baseline;
}
.proFm /deep/ .avatar-uploader{
  width: 23.3rem;
  height: 13.0rem;
}
.proFm /deep/ .avatar-uploader .el-upload,.proFm /deep/ .avatar-uploader .el-upload img{
  // vertical-align: baseline;
  width: 100%;
  height: 100%;
}
/deep/ .current{
  margin-top:0.2rem;
}
/deep/ .el-calendar__header{
  display: none;
}
.conendTime /deep/.el-date-editor{
  width: auto !important;
}
.her{
    width: 10rem;
    height: 4rem;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right:1.5rem;
    cursor: pointer;
}
.btnHer{
  display: flex;
  justify-content: end;
}
::v-deep {
    .el-calendar-table:not(.is-range) td.next,.el-calendar-table:not(.is-range) td.prev{
      pointer-events: none;
    }
  }

  ::v-deep .el-calendar-table:not(.is-range) td.next {
  display: none;
}
::v-deep .el-calendar-table:not(.is-range) td.prev {
  visibility: hidden;
}
.ting{
  text-align: center;
  font-size: 1.8rem;
  color: #333;
}
.el-upload-list__item-thumbnail{
  vertical-align: revert;
}
.son_border{
  border: 1px dashed #E8ECF4;
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 0;
  box-sizing: border-box;
  margin-bottom: 2rem;
  ::v-deep .el-input{
    width: 27rem !important;
  }
  img{
    width: 4rem;
    height: 4rem;
    margin-left: 4.5rem;
    cursor: pointer;
  }
}
.flex_date{
  display: flex;
  flex-direction: column;
  >span{
    text-align: left !important;
    margin-left: 13rem !important;
  }
  ::v-deep .el-form-item{
    margin-bottom:0.5rem !important;
  }
}
.form_ages{
  display: flex;
  align-items: center;
  >span{
    margin: 0 2rem;
  }
}
</style>